import {Component, Input} from '@angular/core';
import {CompanyImageResponse, CompanyResponse} from '../../../../../../@shared/models/response.module';
import {CompanyService} from '../../../../../../@shared/services/company.service';
import {_COR_COY_2, _COR_COY_7} from '../../../../../../@shared/models/input.module';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-company-profile',
  standalone: false,
  templateUrl: './edit-company-profile.html',
  styleUrl: './edit-company-profile.css'
})
export class EditCompanyProfile {
  @Input() company: CompanyResponse

  constructor(private companyService: CompanyService,
              private modal: NgbActiveModal) {
  }

  save(){
    let params: _COR_COY_2 = {
      company_name: this.company.company_name,
      organisation_number: this.company.organisation_number,
      address: this.company.address,
      city: this.company.city,
      postal_code: this.company.postal_code,
      country: this.company.country,
      email: this.company.email,
      phone: this.company.phone,
      description: this.company.description,
    }
    this.companyService.editCompany(params).subscribe((res) => {
      this.company = res
      this.modal.close()
    })
  }
}
